(function () {
  const INPUT_ID = "CollectionLiveSearch";
  const CARD_SELECTOR = "[data-product-card]";
  const STATUS_SELECTOR = ".collection-live-search__status";

  // Tunables
  const MIN_MATCHES_TARGET = 12;     // how many visible matches we try to achieve
  const MAX_AUTOLOAD_PAGES = 20;     // hard safety cap to prevent runaway loading
  const DEBOUNCE_MS = 150;

  let currentQuery = "";
  let autoloading = false;

  function norm(s) {
    return (s || "").toLowerCase().trim();
  }

  function getStatusEl() {
    return document.querySelector(STATUS_SELECTOR);
  }

  function setStatus(msg) {
    const el = getStatusEl();
    if (!el) return;
    if (!msg) {
      el.hidden = true;
      el.textContent = "";
      return;
    }
    el.hidden = false;
    el.textContent = msg;
  }

  function getCards() {
    return Array.from(document.querySelectorAll(CARD_SELECTOR));
  }

  // Updated: filter at the LI level so empty grid spots collapse.
  // Return object now includes visible count.
  function applyFilter() {
    const q = norm(currentQuery);

    // Filter at the GRID ITEM level, not the card level
    const items = Array.from(document.querySelectorAll(".js-pagination__item"));

    let visible = 0;
    let matches = 0;

    items.forEach((item) => {
      const card = item.querySelector(CARD_SELECTOR);

      // If something odd is in the grid, don't blow up
      if (!card) return;

      const hay = norm(card.getAttribute("data-search-text") || card.textContent);
      const ok = q === "" || hay.includes(q);

      // Hide/show the LI so the grid collapses and results float up
      item.style.display = ok ? "" : "none";

      if (ok) matches++;
      if (item.style.display !== "none") visible++;
    });

    return { matches, visible, total: items.length };
  }

  function setCount(visible, total) {
  // only show count when there's a query
  if (!norm(currentQuery)) return setStatus("");
  setStatus(`Showing ${visible} of ${total} products`);
}

  function debounce(fn, ms) {
    let t;
    return function () {
      clearTimeout(t);
      const args = arguments;
      t = setTimeout(() => fn.apply(null, args), ms);
    };
  }

  // Find your infinite scroll component on the page
  function getInfiniteScrollEl() {
    return document.querySelector("infinite-scroll");
  }

  function canLoadMore(infiniteEl) {
    if (!infiniteEl) return false;
    const nextBtn = infiniteEl.querySelector(".js-pagination__next-button[href]");
    const pagination = infiniteEl.querySelector(".js-pagination");
    return Boolean(pagination && nextBtn);
  }

  function wait(ms) {
    return new Promise((r) => setTimeout(r, ms));
  }

  // Wait until new items are appended (or we time out)
  function waitForNewItems(prevCount, timeoutMs = 3000) {
    const start = Date.now();
    return new Promise((resolve) => {
      const tick = () => {
        const nowCount = getCards().length;
        if (nowCount > prevCount) return resolve(true);
        if (Date.now() - start > timeoutMs) return resolve(false);
        requestAnimationFrame(tick);
      };
      tick();
    });
  }

  async function autoloadUntilEnoughMatches() {
    const infiniteEl = getInfiniteScrollEl();
    if (!infiniteEl) return;

    // Only autoload when there is a query
    if (!norm(currentQuery)) return;

    if (autoloading) return;
    autoloading = true;

    try {
      for (let i = 0; i < MAX_AUTOLOAD_PAGES; i++) {
        const { matches } = applyFilter();
        if (matches >= MIN_MATCHES_TARGET) {
          setStatus("");
          return;
        }

        if (!canLoadMore(infiniteEl)) {
          const final = applyFilter();
          if (final.matches === 0) {
            setStatus("No matching products found in this collection.");
          } else {
            setStatus("");
          }
          return;
        }

        setStatus("Searching… loading more products");

        const before = getCards().length;

        // Call your component’s method directly
        if (typeof infiniteEl.fetchNextItems === "function") {
          await infiniteEl.fetchNextItems();
        } else {
          // Fallback: click the next button
          const btn = infiniteEl.querySelector(".js-pagination__next-button[href]");
          if (!btn) return;
          btn.click();
        }

        // Wait until items are appended, then re-filter
        await waitForNewItems(before, 4000);
        applyFilter();

        // Small delay so we don’t hammer requests (your component already throttles too)
        await wait(200);
      }

      setStatus("Reached the search load limit. Refine your search to narrow results.");
    } finally {
      autoloading = false;
      // If query still exists but matches are fine, clear status
      const res = applyFilter();

if (!norm(currentQuery)) {
  setStatus("");
  return;
}

// If we still have matches, show the count
if (res.visible > 0) {
  setCount(res.visible, res.total);
} else {
  setStatus("No matching products found in this collection.");
}
    }
  }

  function init() {
    const input = document.getElementById(INPUT_ID);
    if (!input) return;

    const onInput = debounce(() => {
      currentQuery = input.value;

      const res = applyFilter();

      if (!norm(currentQuery)) {
        setStatus("");
        return;
      }
      setCount(res.visible, res.total);

      // If we have some matches, cool. If not enough, start autoload.
      if (res.matches < MIN_MATCHES_TARGET) {
        autoloadUntilEnoughMatches();
      } else {
        setStatus("");
      }
    }, DEBOUNCE_MS);

    input.addEventListener("input", onInput);

    // If infinite scroll appends new nodes, keep applying current filter
    const infiniteEl = getInfiniteScrollEl();
    const observeRoot = infiniteEl || document.body;

    const mo = new MutationObserver(() => {
      if (norm(currentQuery)) applyFilter();
    });

    mo.observe(observeRoot, { childList: true, subtree: true });
  }

  document.addEventListener("DOMContentLoaded", init);
})();
